var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"editorTitle",staticClass:"toolbar"}),_c('div',{ref:"editorCon",staticClass:"toolbar",style:({height: _vm.myHeight})},[_c('p',[_vm._v("请输入内容")])])])}
var staticRenderFns = []

export { render, staticRenderFns }